// extracted by mini-css-extract-plugin
export default {"SVGContainer":"SVGViewer_SVGContainer__PM-km"};